import { render } from "./Breage.vue?vue&type=template&id=dc06e38e"
import script from "./Breage.vue?vue&type=script&lang=js"
export * from "./Breage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Apple/Desktop/projects/guguop/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__